import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'core/services/store.service';

@Component({
  selector: 'lms-list-header',
  templateUrl: './list-header.component.html',
  styleUrls: ['./list-header.component.scss']
})
export class ListHeaderComponent implements OnInit, OnDestroy {
  @Input() listId: string;
  @Input() field: string;
  @Input() label: string;
  @Input() disableSort: boolean = false;
  public listSubscription: any;
  order = '';

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      if (data && data.sort) {
        this.setArrow(data.sort);
      }
    });
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe();
  }

  setArrow(field: string) {
    this.order =
      this.field && field.startsWith('-' + this.field)
        ? 'desc'
        : this.field && field.startsWith(this.field)
        ? 'asc'
        : '';
  }

  sortBy(field) {
    field = this.order === 'asc' ? '-' + field : field;
    StoreService.merge(this.listId, { sort: field, page: 1, active: true });
  }
}
